import { BACKEND_PRIVATE } from '../base'

export async function getNotifications(limit: number, offset: number) {
  return BACKEND_PRIVATE.get<LX.Paginated<{ notifications: LX.NotificationListItem[] }>>('/me/notifications/list', {
    params: {
      limit: limit,
      offset: offset,
    },
  })
}

export async function getUnreadNotificationsCount() {
  return BACKEND_PRIVATE.get('/me/notifications/unread')
}

export async function readNotifications(ids: number[]) {
  return BACKEND_PRIVATE.post('/me/notifications/read', { payload: { ids } })
}
